module.exports = __webpack_public_path__ + "static/media/brendan.959a5d86.jpg";